export default "__VITE_ASSET__DprCq5jl__"